export default {
    welcome: "<strong>Welcome</strong><br /> Here are privileges for you.",
    redeemHistory: "Redeem History",
    outOfStock: "Out of Stock",
    buttons: {
        redeenNow: "Redeem Now",
        showDetail: "Show Detail"
    },
    redeemable: "Redeemable remains x{0}",
}
